import { render, staticRenderFns } from "./orderFollowPeo.vue?vue&type=template&id=755d365d&scoped=true"
import script from "./orderFollowPeo.vue?vue&type=script&lang=js"
export * from "./orderFollowPeo.vue?vue&type=script&lang=js"
import style0 from "./orderFollowPeo.vue?vue&type=style&index=0&id=755d365d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755d365d",
  null
  
)

export default component.exports